<template>
  <div :class="{ 'page-class': !$store.getters.tableConfig.card }">
    <div class="search">
      <avue-form ref="searchForm" v-model="searchData" :option="searchOption" @submit="searchChange" @reset-change="searchReset">
        <template slot="menuForm">
          <el-button icon="el-icon-download" @click="searchExcel()">导出</el-button>
        </template>
      </avue-form>
    </div>
    <avue-crud
      :data="tableData"
      :option="tbleOption"
      @refresh-change="getList"
      @on-load="onLoad"
      @search-change="searchChange"
      @search-reset="searchReset"
      :page.sync="page"
    >
      <template slot-scope="{type,size,row,index}" slot="menu">
        <el-button icon="el-icon-view" :size="size" :type="type" @click.stop="rowView(row)">查看</el-button>
        <el-button icon="el-icon-edit-outline" v-if="row.status != 5" :size="size" :type="type" @click.stop="addDialogForm(row,index)">审核</el-button>
      </template>
    </avue-crud>
    
    <el-dialog title="提现详情" size="70%" 
      :close-on-click-modal="false" 
      :visible.sync="dialogVisible"
      @close="dialogCloseCallback"
    >
      <avue-form ref="form" v-model="formDa" :option="formOp" @submit="rowUpdate">
        <template slot="bank_id">
          <p>户名:{{formDa.bank.owner}} 手机号:{{formDa.bank.mobile}} 身份证:{{formDa.bank.idcard}}</p>
          <p>开户行:{{formDa.bank.bank}} {{formDa.bank.account}} </p>
          <p>卡号:{{formDa.bank.bank_no}}</p>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
import List from './list';

export default List;
</script>
